/** Ordem canônica de exibição dos módulos. */
export const PERMISSAO_MODULO_ORDER = [
    'ATENDIMENTO',
    'PRE_PRODUCAO',
    'COMPRAS',
    'PRODUCAO',
    'CRIACAO',
    'FINANCEIRO',
    'PLANEJAMENTO',
    'TECNOLOGIA',
    'ACESSO',
    'GERAL',
];
/** Label legível de cada módulo (fonte única do texto exibido). */
export const PERMISSAO_MODULO_LABEL = {
    ATENDIMENTO: 'Atendimento',
    PRE_PRODUCAO: 'Pré-Produção',
    COMPRAS: 'Compras',
    PRODUCAO: 'Produção',
    CRIACAO: 'Criação',
    FINANCEIRO: 'Financeiro',
    PLANEJAMENTO: 'Planejamento',
    TECNOLOGIA: 'Tecnologia',
    ACESSO: 'Acesso & Admin',
    GERAL: 'Geral',
};
const hasToken = (n, token) => new RegExp(`(^|_)${token}($|_)`).test(n);
/**
 * Resolve o módulo de uma permissão a partir do seu nome.
 * A ordem das regras importa (mais específico/área primeiro).
 */
export function getPermissaoModulo(nome) {
    const n = nome.toUpperCase();
    // 1) Acesso & Administração
    if (n === 'ADMIN' || n === 'OPERADOR')
        return 'ACESSO';
    if (/^(PESSOA|ROLE|PERMISSAO)_/.test(n))
        return 'ACESSO';
    if (n === 'MENU_ADMIN')
        return 'ACESSO';
    if (/^ROTA_/.test(n) && /(USUARIOS|PERMISSOES|SQUADS|CLIENTES|TAREFAS_ADMIN|PROCESSAMENTO_IA)/.test(n)) {
        return 'ACESSO';
    }
    // 2) Áreas (a área vence a capacidade)
    if (n.includes('CRIACAO'))
        return 'CRIACAO';
    if (n.includes('TECNOLOGIA'))
        return 'TECNOLOGIA';
    if (n.includes('PLANEJAMENTO'))
        return 'PLANEJAMENTO';
    if (hasToken(n, 'PRE') || n.includes('PRE_PRODUCAO') || n.includes('VERSOES_PRE') || n.includes('DIRETORIA_PRE')) {
        return 'PRE_PRODUCAO';
    }
    if (n.includes('COMPRAS'))
        return 'COMPRAS';
    if (n.includes('PRODUCAO_GRAFICA'))
        return 'PRODUCAO';
    if (n.includes('ATENDIMENTO') || n.includes('CREDITO') || n.includes('CREDITAVEIS'))
        return 'ATENDIMENTO';
    // 3) Capacidades de domínio
    if (n.includes('FINANCEIRO') ||
        n.includes('FINANCE') ||
        n.includes('FATURAMENTO') ||
        n.includes('CONCILIACAO') ||
        n.includes('ADIANTAMENTOS') ||
        /^AP_/.test(n) ||
        hasToken(n, 'AP') ||
        n.includes('NOTA_FISCAL') ||
        n.includes('COMPROVANTE_ENTREGA')) {
        return 'FINANCEIRO';
    }
    if (n.includes('PRODUCAO'))
        return 'PRODUCAO';
    // 4) Fallbacks por entidade
    if (/^VERSAO/.test(n))
        return 'PRE_PRODUCAO';
    if (hasToken(n, 'JOB') || hasToken(n, 'JOBS'))
        return 'ATENDIMENTO';
    // 5) Geral (planilhas genéricas, aprovações, dashboards executivos, etc.)
    return 'GERAL';
}
